import { createContext } from 'react';
import { FilterModel } from 'ts/hotel/classes/FilterModel';
import { NeighborhoodHotel } from 'ts/hotel/interfaces/HotelResponse';

export const HotelFilterContext = createContext({
  filter: undefined as FilterModel | undefined,
  setFilter: (_filter: FilterModel) => {},
  neighborhoodList: [] as NeighborhoodHotel[],
  setNeighborhoodList: (
    _neighborhoodList: NeighborhoodHotel[] | ((prev: NeighborhoodHotel[]) => NeighborhoodHotel[])
  ) => {},
});
